import React from "react";
import { ObjectListValues, SortableListValues } from "../";

export const ObjectListImages = (props) => <ObjectListValues {...props} editText="Editar imagen" addText="Agregar imagen" SortableList={SortableListValues} />
